import { NavLink, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { Common } from "@src/styles/Common";
import LoginUser from "@src/layout/LoginUser";
import Logo from "@src/assets/logo_gd.png";
import PropTypes from "prop-types";
import SideMenuList from "./SideMenuList";
import activeIcon from "@src/assets/sideMenu_active.png";
import activeSettingIcon from "@src/assets/activeSettingIcon.png";
import { css } from "@emotion/react";
import inactiveIcon from "@src/assets/sideMenu_unactive.png";
import settingIcon from "@src/assets/settingIcon.png";

function SideMenu() {
    const getTitle =
        window?.location.host.indexOf("localhost") >= 0
            ? "LOCAL"
            : window?.location.host.indexOf("dev") >= 0
            ? "DEV"
            : window?.location.host.indexOf("sadmincho") >= 0
            ? "STAGE"
            : "";
    const { pathname } = useLocation();
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        setMobileOpen(false);
    }, [pathname]);

    return (
        <>
            {!pathname.includes("/coupon/detail") && (
                <>
                    <button
                        css={hamburgerBtn}
                        onClick={() => setMobileOpen(!mobileOpen)}
                        aria-label="메뉴 열기"
                    >
                        <span css={hamburgerLine(mobileOpen)} />
                        <span css={hamburgerLine(mobileOpen)} />
                        <span css={hamburgerLine(mobileOpen)} />
                    </button>
                    {mobileOpen && (
                        <div
                            css={overlay}
                            onClick={() => setMobileOpen(false)}
                        />
                    )}
                    <div
                        css={GnbDiv(mobileOpen)}
                        className="GnbDiv"
                    >
                        <h2 css={LogoH2} className="logo">
                            <NavLink to="/home">
                                <img src={Logo} alt="미스고" />
                            </NavLink>
                            <div className="text">{getTitle}</div>
                        </h2>
                        <LoginUser />
                        <ul css={userList}>
                            <li>
                                <NavLink
                                    to="/myPage/list"
                                    className={({ isActive }) =>
                                        isActive ? "active" : undefined
                                    }
                                >
                                    마이페이지
                                </NavLink>
                            </li>
                        </ul>
                        <SideMenuList />
                    </div>
                </>
            )}
        </>
    );
}

SideMenu.propTypes = {
    name: PropTypes.string,
    email: PropTypes.string,
};

const hamburgerBtn = css`
    display: none;
    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 5px;
        position: fixed;
        top: 12px;
        left: 12px;
        z-index: 1001;
        background: ${Common.colors.gray100};
        border: 1px solid ${Common.colors.gray200};
        border-radius: 6px;
        padding: 8px;
        cursor: pointer;
    }
`;

const hamburgerLine = (open: boolean) => css`
    display: block;
    width: 20px;
    height: 2px;
    background: ${Common.colors.black};
    border-radius: 2px;
    transition: transform 0.2s, opacity 0.2s;
    ${open &&
    `
        &:nth-of-type(1) {
            transform: rotate(45deg) translate(5px, 5px);
        }
        &:nth-of-type(2) {
            opacity: 0;
        }
        &:nth-of-type(3) {
            transform: rotate(-45deg) translate(5px, -5px);
        }
    `}
`;

const overlay = css`
    display: none;
    @media (max-width: 768px) {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        z-index: 999;
    }
`;

const GnbDiv = (open: boolean) => css`
    min-width: 235px;
    height: 100vh;
    background: ${Common.colors.gray100};
    padding: 40px 30px 0;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    overflow-y: auto;
    @media (max-width: 768px) {
        height: 100vh;
        height: 100dvh;
        padding-bottom: env(safe-area-inset-bottom, 40px);
        transform: translateX(${open ? "0" : "-100%"});
        transition: transform 0.3s ease;
    }
`;

const LogoH2 = css`
    width: 82px;
    height: auto;
    margin-bottom: 20px;
    img {
        display: block;
        width: 100%;
    }
    & > .text {
        position: absolute;
        font-size: 34px;
        right: 50px;
    }
`;
const userList = css`
    border-bottom: 1.5px solid ${Common.colors.white};
    padding-bottom: 11px;
    margin-top: unset;
    li {
        ${Common.textStyle.title6_R14}
        a {
            display: block;
            width: 100%;
            height: 100%;
            text-indent: 20px;
            background: url(${settingIcon}) no-repeat left center, url(${inactiveIcon}) no-repeat right center;
            background-size: 13.33px 13.33px, 7px 11px;
        }
        a.active {
            color: ${Common.colors.focus};
            background: url(${activeSettingIcon}) no-repeat left center, url(${activeIcon}) no-repeat right center;
            background-size: 13.33px 13.33px, 11px 7px;
        }
    }
`;
export default SideMenu;
